import { Stack } from '@mui/material';
import { Cell, Text } from '@telegram-apps/telegram-ui';
import { CommonIcon } from '../../common/CommonIcon';
import { CustomSection } from '../../common/CustomSection';
import { useTranslation } from 'react-i18next';

export type QuestHeaderEmptyProps = {
    onClick: () => void;
};

export const QuestHeaderEmpty = ({ onClick }: QuestHeaderEmptyProps) => {
    const { t } = useTranslation('common');
    return (
    <Stack direction="row" justifyContent="center" minHeight="var(--tg-viewport-content-safe-area-inset-top)">
        <CustomSection onClick={onClick}>
            <Cell
                style={{ gap: '10px', '--tgui--cell--middle--padding': '6px 0 10px 0' } as any}
                before={<CommonIcon icon="flag" type="filled" size={20} color="var(--tgui--link_color)" />}
                subtitle={
                    <Text weight="3" style={{ fontSize: '10px', lineHeight: '10px' }}>
                        {t('quest.goals.choose')}
                    </Text>
                }
            >
                <Text style={{ fontSize: '14px', lineHeight: '14px' }}>
                    {t('quest.goals.setup')}
                </Text>
            </Cell>
        </CustomSection>
    </Stack>
    );
};
